import { InventoryItemViewModel } from "./inventory-item-view-model";

export class InventoryItemGroup {
  primaryItem: InventoryItemViewModel = new InventoryItemViewModel();
  secondaryItems: InventoryItemViewModel[] = [];

  constructor(primaryItem: InventoryItemViewModel, secondaryItems: InventoryItemViewModel[]) {
    this.primaryItem = primaryItem;
    this.secondaryItems = secondaryItems;
  }
}
